let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("leYa9")).then(() => parcelRequire('5ymPj'));